import React, { useState } from 'react'
import { Box, FormHelperText } from '@mui/material'

import { TextInput } from '~components/common'

type AttributionEntryBoxProps = {
  id: string
  name: string
  value: string
  onChange: (id: string, field: 'name' | 'value', newValue: string) => void
}

const AttributionEntryBox: React.FC<AttributionEntryBoxProps> = ({ id, name, value, onChange }) => {
  const [blurred, setBlurred] = useState<boolean>(false)
  const attributionValid =
    (name.trim() === '' && value.trim() === '') || (name.trim() !== '' && value.trim() !== '')
  const showError = blurred && !attributionValid

  const handleBlur = (): void => {
    setBlurred(true)
  }

  const handleFocus = (): void => {
    setBlurred(false)
  }

  return (
    <Box display='flex' flexDirection='column'>
      <Box sx={{ display: 'flex', gap: 2, flexGrow: 1 }}>
        <TextInput
          label='Label'
          value={name}
          onBlur={handleBlur}
          onFocus={handleFocus}
          error={showError}
          onChange={(e) => onChange(id, 'name', e.target.value)}
        />
        <TextInput
          label='Value'
          value={value}
          onBlur={handleBlur}
          onFocus={handleFocus}
          error={showError}
          onChange={(e) => onChange(id, 'value', e.target.value)}
        />
      </Box>
      {showError && (
        <FormHelperText error sx={{ ml: 2, mt: 0.5 }}>
          Please enter a valid attribution name and value
        </FormHelperText>
      )}
    </Box>
  )
}

export default AttributionEntryBox
